import { default as _91_46_46_46slug_93xwPD2ttuTrMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/[...slug].vue?macro=true";
import { default as indexP6F3uvjicbMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/auth/index.vue?macro=true";
import { default as index6yAiV50izsMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/auth/social/[organisation]/[provider]/index.vue?macro=true";
import { default as _91id_93g714M20ML0Meta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/formProcess/[id].vue?macro=true";
import { default as _91id_935wxWmbWHJkMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/formProcess/success/[id].vue?macro=true";
import { default as _91region_93PiRSBub2nPMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/jugend-zaehlt/[region].vue?macro=true";
import { default as _91slug_93fVoW6XYYFeMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/news/[slug].vue?macro=true";
import { default as organisationsrB5xAZKPqiMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/organisations.vue?macro=true";
import { default as grouped_45by_45eventsDXe9Lr2FCGMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/processes/index/grouped-by-events.vue?macro=true";
import { default as grouped_45by_45funding_45programsnOHzy5i8RYMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/processes/index/grouped-by-funding-programs.vue?macro=true";
import { default as indexIvLpXCtAOfMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/processes/index.vue?macro=true";
import { default as dungeonyEWOdI0CmzMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/secret/index/dungeon.vue?macro=true";
import { default as inputs0Rn0NCKTQGMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/secret/index/inputs.vue?macro=true";
import { default as indexKPMi0jOFCPMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/secret/index.vue?macro=true";
import { default as indexeJyWJZzUX2Meta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/basicData/categories/index.vue?macro=true";
import { default as formBaseDatawkCAlCpZDsMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/basicData/forms/[id]/formBaseData.vue?macro=true";
import { default as formClassVCtmQIq9iwMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/basicData/forms/[id]/formClass.vue?macro=true";
import { default as _91id_93YN9iDBqoONMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/basicData/forms/[id].vue?macro=true";
import { default as indexAy7HcLfAtJMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/basicData/forms/index.vue?macro=true";
import { default as fundingProgramBaseDatay87WWaQuu6Meta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramBaseData.vue?macro=true";
import { default as fundingProgramProcessFieldstXfV1D4hUaMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramProcessFields.vue?macro=true";
import { default as fundingProgramReportsTS7yp9ZkNmMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramReports.vue?macro=true";
import { default as fundingProgramRights0UsbCu9l8wMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramRights.vue?macro=true";
import { default as _91id_93A6e9m5RrzWMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/basicData/fundingPrograms/[id].vue?macro=true";
import { default as indexxsd5ckoNwRMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/basicData/fundingPrograms/index.vue?macro=true";
import { default as mailActivitiesuNGDSNHWIqMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/basicData/mails/[id]/mailActivities.vue?macro=true";
import { default as mailBaseDataYMaQRhRESiMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/basicData/mails/[id]/mailBaseData.vue?macro=true";
import { default as _91id_93sohK5rDArlMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/basicData/mails/[id].vue?macro=true";
import { default as indexgoKkNVboPAMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/basicData/mails/index.vue?macro=true";
import { default as mailTemplateActivitiesjryl60vDXVMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/basicData/mailTemplates/[id]/mailTemplateActivities.vue?macro=true";
import { default as mailTemplateBaseDataYrtosOFandMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/basicData/mailTemplates/[id]/mailTemplateBaseData.vue?macro=true";
import { default as _91id_93Rxee4D0HCJMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/basicData/mailTemplates/[id].vue?macro=true";
import { default as indexc8IjFnTqntMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/basicData/mailTemplates/index.vue?macro=true";
import { default as roleBaseDataeSqQDnB4nZMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/basicData/roles/[name]/roleBaseData.vue?macro=true";
import { default as _91name_93K8jyGSQHaUMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/basicData/roles/[name].vue?macro=true";
import { default as indexN1m8kyEim2Meta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/basicData/roles/index.vue?macro=true";
import { default as statisticFormBaseDataFYEM1EsxVXMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/basicData/statisticForms/[id]/statisticFormBaseData.vue?macro=true";
import { default as statisticFormClassR3zRQ5HSv5Meta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/basicData/statisticForms/[id]/statisticFormClass.vue?macro=true";
import { default as statisticFormDedicatedFormsJ73ZdmKNsFMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/basicData/statisticForms/[id]/statisticFormDedicatedForms.vue?macro=true";
import { default as _91id_93RKXfW8u9pGMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/basicData/statisticForms/[id].vue?macro=true";
import { default as indexNUJS40LHvtMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/basicData/statisticForms/index.vue?macro=true";
import { default as statisticSurveyActivitiesqh9aKB2plQMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyActivities.vue?macro=true";
import { default as statisticSurveyBaseData1pKo5VdwTxMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyBaseData.vue?macro=true";
import { default as statisticSurveyPeriodsAolx5uEsgaMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyPeriods.vue?macro=true";
import { default as _91id_93qVwK9XtRkiMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/basicData/statisticSurveys/[id].vue?macro=true";
import { default as index8fZPvWLZ9AMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/basicData/statisticSurveys/index.vue?macro=true";
import { default as statusActivitiesBTDJ5DOc28Meta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/basicData/statuses/[id]/statusActivities.vue?macro=true";
import { default as statusBaseDatahuH5PDTARXMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/basicData/statuses/[id]/statusBaseData.vue?macro=true";
import { default as statusNotificationsEbHkPQVS1wMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/basicData/statuses/[id]/statusNotifications.vue?macro=true";
import { default as _91id_93lO5uVpDRWhMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/basicData/statuses/[id].vue?macro=true";
import { default as indexuziHEZKqrlMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/basicData/statuses/index.vue?macro=true";
import { default as yearBaseDataIVKPtXWRT7Meta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/basicData/years/[id]/yearBaseData.vue?macro=true";
import { default as yearDatavkXk4oR5ZUMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/basicData/years/[id]/yearData.vue?macro=true";
import { default as _91id_93G8vs7BM0iNMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/basicData/years/[id].vue?macro=true";
import { default as indexF6HwvZNXN7Meta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/basicData/years/index.vue?macro=true";
import { default as basicDataNCp0jURnAjMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/basicData.vue?macro=true";
import { default as _91id_93ltAzQlpKLsMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/formProcesses/[id].vue?macro=true";
import { default as indexbQ0D8lPXusMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/index.vue?macro=true";
import { default as parishAgeGroupsDHdsjfWzu9Meta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/jugendzaehlt/parishes/[id]/parishAgeGroups.vue?macro=true";
import { default as parishBaseDataxFXcjkzWiuMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/jugendzaehlt/parishes/[id]/parishBaseData.vue?macro=true";
import { default as _91id_93r3SlSWR7g9Meta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/jugendzaehlt/parishes/[id].vue?macro=true";
import { default as indexBZSSnwM7K0Meta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/jugendzaehlt/parishes/index.vue?macro=true";
import { default as parishesrDitdrhUSNMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/jugendzaehlt/parishes.vue?macro=true";
import { default as regionActivitiesap0TYCLj8lMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/jugendzaehlt/regions/[id]/regionActivities.vue?macro=true";
import { default as regionAgeGroupshiWITfwzKlMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/jugendzaehlt/regions/[id]/regionAgeGroups.vue?macro=true";
import { default as regionBaseDataNlgpX8SmnEMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/jugendzaehlt/regions/[id]/regionBaseData.vue?macro=true";
import { default as regionDiaconiasiLWCAbAyTXMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/jugendzaehlt/regions/[id]/regionDiaconias.vue?macro=true";
import { default as regionParishesTEJfPSQ0tsMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/jugendzaehlt/regions/[id]/regionParishes.vue?macro=true";
import { default as _91id_93Gj0WfdsdjaMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/jugendzaehlt/regions/[id].vue?macro=true";
import { default as indexNJ9VHspoXcMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/jugendzaehlt/regions/index.vue?macro=true";
import { default as regionsxbyh9vLk18Meta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/jugendzaehlt/regions.vue?macro=true";
import { default as jugendzaehlt2Dje9XpTptMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/jugendzaehlt.vue?macro=true";
import { default as paymentRunBaseDataPSVRTyUZByMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/payments/paymentRuns/[id]/paymentRunBaseData.vue?macro=true";
import { default as paymentRunPaymentsP3mpEcLyMxMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/payments/paymentRuns/[id]/paymentRunPayments.vue?macro=true";
import { default as _91id_93PmjP6UvfYoMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/payments/paymentRuns/[id].vue?macro=true";
import { default as indexNen9es1UxlMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/payments/paymentRuns/index.vue?macro=true";
import { default as payments9li1dsLrNLMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/payments.vue?macro=true";
import { default as processActivitiesQFy0fbF1p1Meta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/processes/[id]/processActivities.vue?macro=true";
import { default as processBaseDatarMYwUnAxxYMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/processes/[id]/processBaseData.vue?macro=true";
import { default as _91id_93WjGNwK7k9SMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/processes/[id].vue?macro=true";
import { default as indexA72d1pNb1gMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/processes/index.vue?macro=true";
import { default as _91id_93iWYICACbpqMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/settings/loginProviders/[id].vue?macro=true";
import { default as index7lLPyvuQLoMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/settings/loginProviders/index.vue?macro=true";
import { default as loginProvidersJzUngW37ZYMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/settings/loginProviders.vue?macro=true";
import { default as organisationActivitiesYXzXCwPyILMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/settings/organisations/[id]/organisationActivities.vue?macro=true";
import { default as organisationAssociationSettingscIlttkQraZMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/settings/organisations/[id]/organisationAssociationSettings.vue?macro=true";
import { default as organisationBaseDataKlK8IHwEKIMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/settings/organisations/[id]/organisationBaseData.vue?macro=true";
import { default as organisationCategoriesuW2DI3vvnwMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/settings/organisations/[id]/organisationCategories.vue?macro=true";
import { default as organisationEducationalConceptOQqHTjkfQYMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/settings/organisations/[id]/organisationEducationalConcept.vue?macro=true";
import { default as organisationTransferAgreementtgaO8wBcEOMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/settings/organisations/[id]/organisationTransferAgreement.vue?macro=true";
import { default as organisationUsersqBmgpb1lxHMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/settings/organisations/[id]/organisationUsers.vue?macro=true";
import { default as _91id_93qsOIHChlhcMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/settings/organisations/[id].vue?macro=true";
import { default as indexGMaa8w67AhMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/settings/organisations/index.vue?macro=true";
import { default as organisationsfXnBbCrpzeMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/settings/organisations.vue?macro=true";
import { default as userActivitiesZE2MVRqKl9Meta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/settings/users/[id]/userActivities.vue?macro=true";
import { default as userBaseDataBYZRi7kjFzMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/settings/users/[id]/userBaseData.vue?macro=true";
import { default as userSignatureYrdAlxy8I0Meta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/settings/users/[id]/userSignature.vue?macro=true";
import { default as _91id_93LTI0yQPsFYMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/settings/users/[id].vue?macro=true";
import { default as index7cmuK6ALinMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/settings/users/index.vue?macro=true";
import { default as usersFu0eT2DCUZMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/settings/users.vue?macro=true";
import { default as settingsoOjKC1shfcMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/settings.vue?macro=true";
import { default as statisticProcessActivitiesynDkvgkNLqMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/statisticProcesses/[id]/statisticProcessActivities.vue?macro=true";
import { default as statisticProcessBaseDatarm9FfE8KGYMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/statisticProcesses/[id]/statisticProcessBaseData.vue?macro=true";
import { default as _91id_93aUmk5KlOA2Meta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/statisticProcesses/[id].vue?macro=true";
import { default as indexpx2LHbAV8AMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/statisticProcesses/index.vue?macro=true";
import { default as serviceeraHppuZt9Meta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service.vue?macro=true";
import { default as languagedFpKvTDoozMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/settings/language.vue?macro=true";
import { default as organisationBaseDataqkbZPLfl0VMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/settings/organisations/[id]/organisationBaseData.vue?macro=true";
import { default as organisationCategoriesymVIQUy5SuMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/settings/organisations/[id]/organisationCategories.vue?macro=true";
import { default as organisationTransferAgreementSSrPjxrbM4Meta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/settings/organisations/[id]/organisationTransferAgreement.vue?macro=true";
import { default as organisationUsersyj3YY4M4GbMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/settings/organisations/[id]/organisationUsers.vue?macro=true";
import { default as _91id_93mG9UMn5II6Meta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/settings/organisations/[id].vue?macro=true";
import { default as userBaseDatam6McHydpiUMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/settings/users/[id]/userBaseData.vue?macro=true";
import { default as userSignature0viR0QGeJTMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/settings/users/[id]/userSignature.vue?macro=true";
import { default as _91id_93hwedbqOVKjMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/settings/users/[id].vue?macro=true";
import { default as indexM9iUAEqjUZMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/settings/users/index.vue?macro=true";
import { default as settingsGQO36sauSDMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/settings.vue?macro=true";
import { default as signatureAeJPGoVuDSMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/signature.vue?macro=true";
import { default as sportbizzEBu9Iz7iLJMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/sportbizz.vue?macro=true";
import { default as _91id_93m7kSFZr5Q2Meta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/statisticProcess/[id].vue?macro=true";
import { default as _91id_93y9E3IWE7KzMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/statisticProcess/success/[id].vue?macro=true";
import { default as indexJTHy9G6LusMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/statistics/index.vue?macro=true";
import { default as _91_46_46_46slug_93vYZujMHcXiMeta } from "/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/wiki/[...slug].vue?macro=true";
import { default as sportbizzk99AObOvrmMeta } from "@/pages/sportbizz.vue?macro=true";
export default [
  {
    name: "slug",
    path: "/:slug(.*)*",
    meta: _91_46_46_46slug_93xwPD2ttuTrMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/[...slug].vue")
  },
  {
    name: "auth",
    path: "/auth",
    meta: indexP6F3uvjicbMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/auth/index.vue")
  },
  {
    name: "auth-social-organisation-provider",
    path: "/auth/social/:organisation()/:provider()",
    meta: index6yAiV50izsMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/auth/social/[organisation]/[provider]/index.vue")
  },
  {
    name: "formProcess-id",
    path: "/formProcess/:id()",
    meta: _91id_93g714M20ML0Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/formProcess/[id].vue")
  },
  {
    name: "formProcess-success-id",
    path: "/formProcess/success/:id()",
    meta: _91id_935wxWmbWHJkMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/formProcess/success/[id].vue")
  },
  {
    name: "jugend-zaehlt-region",
    path: "/jugend-zaehlt/:region()",
    meta: _91region_93PiRSBub2nPMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/jugend-zaehlt/[region].vue")
  },
  {
    name: "news-slug",
    path: "/news/:slug()",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/news/[slug].vue")
  },
  {
    name: "organisations",
    path: "/organisations",
    meta: organisationsrB5xAZKPqiMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/organisations.vue")
  },
  {
    name: "processes",
    path: "/processes",
    meta: indexIvLpXCtAOfMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/processes/index.vue"),
    children: [
  {
    name: "processes-index-grouped-by-events",
    path: "grouped-by-events",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/processes/index/grouped-by-events.vue")
  },
  {
    name: "processes-index-grouped-by-funding-programs",
    path: "grouped-by-funding-programs",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/processes/index/grouped-by-funding-programs.vue")
  }
]
  },
  {
    name: "secret",
    path: "/secret",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/secret/index.vue"),
    children: [
  {
    name: "secret-index-dungeon",
    path: "dungeon",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/secret/index/dungeon.vue")
  },
  {
    name: "secret-index-inputs",
    path: "inputs",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/secret/index/inputs.vue")
  }
]
  },
  {
    name: serviceeraHppuZt9Meta?.name,
    path: "/service",
    meta: serviceeraHppuZt9Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service.vue"),
    children: [
  {
    name: "service-basicData",
    path: "basicData",
    meta: basicDataNCp0jURnAjMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/basicData.vue"),
    children: [
  {
    name: "service-basicData-categories",
    path: "categories",
    meta: indexeJyWJZzUX2Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/basicData/categories/index.vue")
  },
  {
    name: "service-basicData-forms-id",
    path: "forms/:id()",
    meta: _91id_93YN9iDBqoONMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/basicData/forms/[id].vue"),
    children: [
  {
    name: "service-basicData-forms-id-formBaseData",
    path: "formBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/basicData/forms/[id]/formBaseData.vue")
  },
  {
    name: "service-basicData-forms-id-formClass",
    path: "formClass",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/basicData/forms/[id]/formClass.vue")
  }
]
  },
  {
    name: "service-basicData-forms",
    path: "forms",
    meta: indexAy7HcLfAtJMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/basicData/forms/index.vue")
  },
  {
    name: "service-basicData-fundingPrograms-id",
    path: "fundingPrograms/:id()",
    meta: _91id_93A6e9m5RrzWMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/basicData/fundingPrograms/[id].vue"),
    children: [
  {
    name: "service-basicData-fundingPrograms-id-fundingProgramBaseData",
    path: "fundingProgramBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramBaseData.vue")
  },
  {
    name: "service-basicData-fundingPrograms-id-fundingProgramProcessFields",
    path: "fundingProgramProcessFields",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramProcessFields.vue")
  },
  {
    name: "service-basicData-fundingPrograms-id-fundingProgramReports",
    path: "fundingProgramReports",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramReports.vue")
  },
  {
    name: "service-basicData-fundingPrograms-id-fundingProgramRights",
    path: "fundingProgramRights",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramRights.vue")
  }
]
  },
  {
    name: "service-basicData-fundingPrograms",
    path: "fundingPrograms",
    meta: indexxsd5ckoNwRMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/basicData/fundingPrograms/index.vue")
  },
  {
    name: "service-basicData-mails-id",
    path: "mails/:id()",
    meta: _91id_93sohK5rDArlMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/basicData/mails/[id].vue"),
    children: [
  {
    name: "service-basicData-mails-id-mailActivities",
    path: "mailActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/basicData/mails/[id]/mailActivities.vue")
  },
  {
    name: "service-basicData-mails-id-mailBaseData",
    path: "mailBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/basicData/mails/[id]/mailBaseData.vue")
  }
]
  },
  {
    name: "service-basicData-mails",
    path: "mails",
    meta: indexgoKkNVboPAMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/basicData/mails/index.vue")
  },
  {
    name: "service-basicData-mailTemplates-id",
    path: "mailTemplates/:id()",
    meta: _91id_93Rxee4D0HCJMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/basicData/mailTemplates/[id].vue"),
    children: [
  {
    name: "service-basicData-mailTemplates-id-mailTemplateActivities",
    path: "mailTemplateActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/basicData/mailTemplates/[id]/mailTemplateActivities.vue")
  },
  {
    name: "service-basicData-mailTemplates-id-mailTemplateBaseData",
    path: "mailTemplateBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/basicData/mailTemplates/[id]/mailTemplateBaseData.vue")
  }
]
  },
  {
    name: "service-basicData-mailTemplates",
    path: "mailTemplates",
    meta: indexc8IjFnTqntMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/basicData/mailTemplates/index.vue")
  },
  {
    name: "service-basicData-roles-name",
    path: "roles/:name()",
    meta: _91name_93K8jyGSQHaUMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/basicData/roles/[name].vue"),
    children: [
  {
    name: "service-basicData-roles-name-roleBaseData",
    path: "roleBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/basicData/roles/[name]/roleBaseData.vue")
  }
]
  },
  {
    name: "service-basicData-roles",
    path: "roles",
    meta: indexN1m8kyEim2Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/basicData/roles/index.vue")
  },
  {
    name: "service-basicData-statisticForms-id",
    path: "statisticForms/:id()",
    meta: _91id_93RKXfW8u9pGMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/basicData/statisticForms/[id].vue"),
    children: [
  {
    name: "service-basicData-statisticForms-id-statisticFormBaseData",
    path: "statisticFormBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/basicData/statisticForms/[id]/statisticFormBaseData.vue")
  },
  {
    name: "service-basicData-statisticForms-id-statisticFormClass",
    path: "statisticFormClass",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/basicData/statisticForms/[id]/statisticFormClass.vue")
  },
  {
    name: "service-basicData-statisticForms-id-statisticFormDedicatedForms",
    path: "statisticFormDedicatedForms",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/basicData/statisticForms/[id]/statisticFormDedicatedForms.vue")
  }
]
  },
  {
    name: "service-basicData-statisticForms",
    path: "statisticForms",
    meta: indexNUJS40LHvtMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/basicData/statisticForms/index.vue")
  },
  {
    name: "service-basicData-statisticSurveys-id",
    path: "statisticSurveys/:id()",
    meta: _91id_93qVwK9XtRkiMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/basicData/statisticSurveys/[id].vue"),
    children: [
  {
    name: "service-basicData-statisticSurveys-id-statisticSurveyActivities",
    path: "statisticSurveyActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyActivities.vue")
  },
  {
    name: "service-basicData-statisticSurveys-id-statisticSurveyBaseData",
    path: "statisticSurveyBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyBaseData.vue")
  },
  {
    name: "service-basicData-statisticSurveys-id-statisticSurveyPeriods",
    path: "statisticSurveyPeriods",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyPeriods.vue")
  }
]
  },
  {
    name: "service-basicData-statisticSurveys",
    path: "statisticSurveys",
    meta: index8fZPvWLZ9AMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/basicData/statisticSurveys/index.vue")
  },
  {
    name: "service-basicData-statuses-id",
    path: "statuses/:id()",
    meta: _91id_93lO5uVpDRWhMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/basicData/statuses/[id].vue"),
    children: [
  {
    name: "service-basicData-statuses-id-statusActivities",
    path: "statusActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/basicData/statuses/[id]/statusActivities.vue")
  },
  {
    name: "service-basicData-statuses-id-statusBaseData",
    path: "statusBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/basicData/statuses/[id]/statusBaseData.vue")
  },
  {
    name: "service-basicData-statuses-id-statusNotifications",
    path: "statusNotifications",
    meta: statusNotificationsEbHkPQVS1wMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/basicData/statuses/[id]/statusNotifications.vue")
  }
]
  },
  {
    name: "service-basicData-statuses",
    path: "statuses",
    meta: indexuziHEZKqrlMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/basicData/statuses/index.vue")
  },
  {
    name: "service-basicData-years-id",
    path: "years/:id()",
    meta: _91id_93G8vs7BM0iNMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/basicData/years/[id].vue"),
    children: [
  {
    name: "service-basicData-years-id-yearBaseData",
    path: "yearBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/basicData/years/[id]/yearBaseData.vue")
  },
  {
    name: "service-basicData-years-id-yearData",
    path: "yearData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/basicData/years/[id]/yearData.vue")
  }
]
  },
  {
    name: "service-basicData-years",
    path: "years",
    meta: indexF6HwvZNXN7Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/basicData/years/index.vue")
  }
]
  },
  {
    name: "service-formProcesses-id",
    path: "formProcesses/:id()",
    meta: _91id_93ltAzQlpKLsMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/formProcesses/[id].vue")
  },
  {
    name: "service",
    path: "",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/index.vue")
  },
  {
    name: "service-jugendzaehlt",
    path: "jugendzaehlt",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/jugendzaehlt.vue"),
    children: [
  {
    name: parishesrDitdrhUSNMeta?.name,
    path: "parishes",
    meta: parishesrDitdrhUSNMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/jugendzaehlt/parishes.vue"),
    children: [
  {
    name: "service-jugendzaehlt-parishes-id",
    path: ":id()",
    meta: _91id_93r3SlSWR7g9Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/jugendzaehlt/parishes/[id].vue"),
    children: [
  {
    name: "service-jugendzaehlt-parishes-id-parishAgeGroups",
    path: "parishAgeGroups",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/jugendzaehlt/parishes/[id]/parishAgeGroups.vue")
  },
  {
    name: "service-jugendzaehlt-parishes-id-parishBaseData",
    path: "parishBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/jugendzaehlt/parishes/[id]/parishBaseData.vue")
  }
]
  },
  {
    name: "service-jugendzaehlt-parishes",
    path: "",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/jugendzaehlt/parishes/index.vue")
  }
]
  },
  {
    name: regionsxbyh9vLk18Meta?.name,
    path: "regions",
    meta: regionsxbyh9vLk18Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/jugendzaehlt/regions.vue"),
    children: [
  {
    name: "service-jugendzaehlt-regions-id",
    path: ":id()",
    meta: _91id_93Gj0WfdsdjaMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/jugendzaehlt/regions/[id].vue"),
    children: [
  {
    name: "service-jugendzaehlt-regions-id-regionActivities",
    path: "regionActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/jugendzaehlt/regions/[id]/regionActivities.vue")
  },
  {
    name: "service-jugendzaehlt-regions-id-regionAgeGroups",
    path: "regionAgeGroups",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/jugendzaehlt/regions/[id]/regionAgeGroups.vue")
  },
  {
    name: "service-jugendzaehlt-regions-id-regionBaseData",
    path: "regionBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/jugendzaehlt/regions/[id]/regionBaseData.vue")
  },
  {
    name: "service-jugendzaehlt-regions-id-regionDiaconias",
    path: "regionDiaconias",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/jugendzaehlt/regions/[id]/regionDiaconias.vue")
  },
  {
    name: "service-jugendzaehlt-regions-id-regionParishes",
    path: "regionParishes",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/jugendzaehlt/regions/[id]/regionParishes.vue")
  }
]
  },
  {
    name: "service-jugendzaehlt-regions",
    path: "",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/jugendzaehlt/regions/index.vue")
  }
]
  }
]
  },
  {
    name: "service-payments",
    path: "payments",
    meta: payments9li1dsLrNLMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/payments.vue"),
    children: [
  {
    name: "service-payments-paymentRuns-id",
    path: "paymentRuns/:id()",
    meta: _91id_93PmjP6UvfYoMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/payments/paymentRuns/[id].vue"),
    children: [
  {
    name: "service-payments-paymentRuns-id-paymentRunBaseData",
    path: "paymentRunBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/payments/paymentRuns/[id]/paymentRunBaseData.vue")
  },
  {
    name: "service-payments-paymentRuns-id-paymentRunPayments",
    path: "paymentRunPayments",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/payments/paymentRuns/[id]/paymentRunPayments.vue")
  }
]
  },
  {
    name: "service-payments-paymentRuns",
    path: "paymentRuns",
    meta: indexNen9es1UxlMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/payments/paymentRuns/index.vue")
  }
]
  },
  {
    name: "service-processes-id",
    path: "processes/:id()",
    meta: _91id_93WjGNwK7k9SMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/processes/[id].vue"),
    children: [
  {
    name: "service-processes-id-processActivities",
    path: "processActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/processes/[id]/processActivities.vue")
  },
  {
    name: "service-processes-id-processBaseData",
    path: "processBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/processes/[id]/processBaseData.vue")
  }
]
  },
  {
    name: "service-processes",
    path: "processes",
    meta: indexA72d1pNb1gMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/processes/index.vue")
  },
  {
    name: "service-settings",
    path: "settings",
    meta: settingsoOjKC1shfcMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/settings.vue"),
    children: [
  {
    name: loginProvidersJzUngW37ZYMeta?.name,
    path: "loginProviders",
    meta: loginProvidersJzUngW37ZYMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/settings/loginProviders.vue"),
    children: [
  {
    name: "service-settings-loginProviders-id",
    path: ":id()",
    meta: _91id_93iWYICACbpqMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/settings/loginProviders/[id].vue")
  },
  {
    name: "service-settings-loginProviders",
    path: "",
    meta: index7lLPyvuQLoMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/settings/loginProviders/index.vue")
  }
]
  },
  {
    name: organisationsfXnBbCrpzeMeta?.name,
    path: "organisations",
    meta: organisationsfXnBbCrpzeMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/settings/organisations.vue"),
    children: [
  {
    name: "service-settings-organisations-id",
    path: ":id()",
    meta: _91id_93qsOIHChlhcMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/settings/organisations/[id].vue"),
    children: [
  {
    name: "service-settings-organisations-id-organisationActivities",
    path: "organisationActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/settings/organisations/[id]/organisationActivities.vue")
  },
  {
    name: "service-settings-organisations-id-organisationAssociationSettings",
    path: "organisationAssociationSettings",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/settings/organisations/[id]/organisationAssociationSettings.vue")
  },
  {
    name: "service-settings-organisations-id-organisationBaseData",
    path: "organisationBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/settings/organisations/[id]/organisationBaseData.vue")
  },
  {
    name: "service-settings-organisations-id-organisationCategories",
    path: "organisationCategories",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/settings/organisations/[id]/organisationCategories.vue")
  },
  {
    name: "service-settings-organisations-id-organisationEducationalConcept",
    path: "organisationEducationalConcept",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/settings/organisations/[id]/organisationEducationalConcept.vue")
  },
  {
    name: "service-settings-organisations-id-organisationTransferAgreement",
    path: "organisationTransferAgreement",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/settings/organisations/[id]/organisationTransferAgreement.vue")
  },
  {
    name: "service-settings-organisations-id-organisationUsers",
    path: "organisationUsers",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/settings/organisations/[id]/organisationUsers.vue")
  }
]
  },
  {
    name: "service-settings-organisations",
    path: "",
    meta: indexGMaa8w67AhMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/settings/organisations/index.vue")
  }
]
  },
  {
    name: usersFu0eT2DCUZMeta?.name,
    path: "users",
    meta: usersFu0eT2DCUZMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/settings/users.vue"),
    children: [
  {
    name: "service-settings-users-id",
    path: ":id()",
    meta: _91id_93LTI0yQPsFYMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/settings/users/[id].vue"),
    children: [
  {
    name: "service-settings-users-id-userActivities",
    path: "userActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/settings/users/[id]/userActivities.vue")
  },
  {
    name: "service-settings-users-id-userBaseData",
    path: "userBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/settings/users/[id]/userBaseData.vue")
  },
  {
    name: "service-settings-users-id-userSignature",
    path: "userSignature",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/settings/users/[id]/userSignature.vue")
  }
]
  },
  {
    name: "service-settings-users",
    path: "",
    meta: index7cmuK6ALinMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/settings/users/index.vue")
  }
]
  }
]
  },
  {
    name: "service-statisticProcesses-id",
    path: "statisticProcesses/:id()",
    meta: _91id_93aUmk5KlOA2Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/statisticProcesses/[id].vue"),
    children: [
  {
    name: "service-statisticProcesses-id-statisticProcessActivities",
    path: "statisticProcessActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/statisticProcesses/[id]/statisticProcessActivities.vue")
  },
  {
    name: "service-statisticProcesses-id-statisticProcessBaseData",
    path: "statisticProcessBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/statisticProcesses/[id]/statisticProcessBaseData.vue")
  }
]
  },
  {
    name: "service-statisticProcesses",
    path: "statisticProcesses",
    meta: indexpx2LHbAV8AMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/service/statisticProcesses/index.vue")
  }
]
  },
  {
    name: "settings",
    path: "/settings",
    meta: settingsGQO36sauSDMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/settings.vue"),
    children: [
  {
    name: "settings-language",
    path: "language",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/settings/language.vue")
  },
  {
    name: "settings-organisations-id",
    path: "organisations/:id()",
    meta: _91id_93mG9UMn5II6Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/settings/organisations/[id].vue"),
    children: [
  {
    name: "settings-organisations-id-organisationBaseData",
    path: "organisationBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/settings/organisations/[id]/organisationBaseData.vue")
  },
  {
    name: "settings-organisations-id-organisationCategories",
    path: "organisationCategories",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/settings/organisations/[id]/organisationCategories.vue")
  },
  {
    name: "settings-organisations-id-organisationTransferAgreement",
    path: "organisationTransferAgreement",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/settings/organisations/[id]/organisationTransferAgreement.vue")
  },
  {
    name: "settings-organisations-id-organisationUsers",
    path: "organisationUsers",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/settings/organisations/[id]/organisationUsers.vue")
  }
]
  },
  {
    name: "settings-users-id",
    path: "users/:id()",
    meta: _91id_93hwedbqOVKjMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/settings/users/[id].vue"),
    children: [
  {
    name: "settings-users-id-userBaseData",
    path: "userBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/settings/users/[id]/userBaseData.vue")
  },
  {
    name: "settings-users-id-userSignature",
    path: "userSignature",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/settings/users/[id]/userSignature.vue")
  }
]
  },
  {
    name: "settings-users",
    path: "users",
    meta: indexM9iUAEqjUZMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/settings/users/index.vue")
  }
]
  },
  {
    name: "signature",
    path: "/signature",
    meta: signatureAeJPGoVuDSMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/signature.vue")
  },
  {
    name: "sportbizz",
    path: "/sportbizz",
    meta: sportbizzEBu9Iz7iLJMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/sportbizz.vue")
  },
  {
    name: "statisticProcess-id",
    path: "/statisticProcess/:id()",
    meta: _91id_93m7kSFZr5Q2Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/statisticProcess/[id].vue")
  },
  {
    name: "statisticProcess-success-id",
    path: "/statisticProcess/success/:id()",
    meta: _91id_93y9E3IWE7KzMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/statisticProcess/success/[id].vue")
  },
  {
    name: "statistics",
    path: "/statistics",
    meta: indexJTHy9G6LusMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/statistics/index.vue")
  },
  {
    name: "wiki-slug",
    path: "/wiki/:slug(.*)*",
    meta: _91_46_46_46slug_93vYZujMHcXiMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250514150259/client/pages/wiki/[...slug].vue")
  },
  {
    name: "sportbizz",
    path: "/index/welcome/p/sportbizz",
    meta: sportbizzk99AObOvrmMeta || {},
    component: () => import("@/pages/sportbizz.vue")
  }
]